// extracted by mini-css-extract-plugin
export default {"buttonWithSpinner":"button-with-spinner__button-with-spinner__TE5WA","spinner":"button-with-spinner__spinner__EIKnJ"};